import React from 'react';
import intl from 'react-intl-universal';

import { ArticleType } from '@/type/article';

import styles from './index.module.less';
import ListItem from './ListItem';

function Index({ list, toArticle }: { list: ArticleType[]; toArticle: (id: string) => void }) {
    return (
        <div className={styles.wrapper__faq}>
            <h2 className={styles.title}>{intl.get('Broker.FAQNavs').d('常见问题')}</h2>
            {list.map((item) => {
                const { code, seo_url } = item;
                return (
                    <div
                        onClick={() => {
                            toArticle(seo_url || code);
                        }}
                        className={styles.item__list}
                        key={code}
                    >
                        <ListItem dataSource={item} />
                    </div>
                );
            })}
        </div>
    );
}

export default Index;
